export default __webpack_public_path__ + "static/media/default-profile-pic.cb69260f.png";